import { isNil } from 'lodash';
import React from 'react';
import './ReviewStars.scss';

const ReviewStars = (props) => {
    const stars = [];

    for (let i = 0; i < props.maxRating; i++) {
        stars.push(
            <span key={i} className={`star ${i < props.average ? 'on' : ''}`}>
                &#x02605;
            </span>
        );
    }

    return (
        <>
            {!isNil(props.count) && <span>{`(${props.count}) `}</span>}
            {stars}
        </>
    );
};

export default ReviewStars;
